import { useEffect } from "react";
import { useSelector } from "react-redux";
import { SignOut } from 'config/helper';

const timeout = 1000 * 30
const events = ["mousemove", "keydown", "click", "touchstart", "touchmove", "scroll", "wheel"];

function useAutoLogout() {
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  useEffect(() => {
    if (!isUserLoggedIn) {
      return;
    }

    // shared localStorage timestamp: one clock across tabs, immune to timer throttling
    let last = 0;
    const touch = () => {
      if (Date.now() - last < 1000) return;
      last = Date.now();
      try { localStorage.setItem("lastActivity", last); } catch (e) { /* storage unavailable: fall back to in-memory last */ }
    };
    const check = () => {
      // iframe (payment form) activity never reaches window
      if (document.activeElement?.tagName === "IFRAME") return touch();
      if (Date.now() - (localStorage.getItem("lastActivity") || last) > timeout) SignOut();
    };

    touch();
    events.forEach((e) => window.addEventListener(e, touch, true));
    document.addEventListener("visibilitychange", check);
    const id = setInterval(check, 5000);

    return () => {
      events.forEach((e) => window.removeEventListener(e, touch, true));
      document.removeEventListener("visibilitychange", check);
      clearInterval(id);
    };
  }, [isUserLoggedIn])

  return null;
}

export default useAutoLogout;
